var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "material-input",
    {
      class:
        _vm.containerClassName +
        " " +
        (_vm.label ? "" : "form-group-material-no-label"),
      attrs: { placeholder: _vm.placeholder },
    },
    [
      _c(
        "select",
        {
          staticClass:
            "form-control material-input py-0 form my-1 moregage-data select-field",
          class: _vm.selectClassName,
          attrs: {
            id: _vm.id,
            name: _vm.name,
            disabled: _vm.disabled,
            tabindex: _vm.tabindex,
            required: _vm.required,
          },
          on: { change: _vm.handleInput },
        },
        [
          _vm.placeholderOption
            ? _c(
                "option",
                {
                  staticClass: "text-grey",
                  attrs: { value: "" },
                  domProps: { selected: _vm.defaultSelect },
                },
                [_vm._v("\n      " + _vm._s(_vm.placeholder) + "\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.options, function (option) {
            return _c(
              "option",
              {
                key: option.value,
                class: option.disabled ? "text-grey bg-grey" : "",
                attrs: { disabled: option.disabled },
                domProps: {
                  selected: _vm.setSelectedOption(option),
                  value: option.value,
                },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm._f("getSchemaTranslation")(
                        option.label,
                        _vm.translationMap
                      )
                    ) +
                    "\n    "
                ),
              ]
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("section-error", { attrs: { "error-message": _vm.errorMessage } }),
      _vm._v(" "),
      _c("span", { staticClass: "bar" }),
      _vm._v(" "),
      _vm.label
        ? _c(
            "label",
            {
              staticClass: "title text-light-gray mb-2 mb-lg-0",
              class: { hidden: _vm.hiddenLabel },
              attrs: { for: _vm.labelValue },
            },
            [_vm._v(_vm._s(_vm.label))]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }